import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http";

type EntityListObject = {
  entity_list: Array<string>;
};

function getEntities() {
  return api.governance
    .get<EntityListObject>("gcp/pii/full_entity_list")
    .json();
}

export const governanceEntitiesQueryOptions = queryOptions({
  queryKey: ["governance", "entities"],
  queryFn: getEntities,
  select: (data) => data.entity_list,
});

export function useGovernanceEntityList() {
  return useQuery(governanceEntitiesQueryOptions);
}
